module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAZCAMAAAD3wqVsAAAAM1BMVEVHcEz////////////////////////////////////////////////////////////////P0YphAAAAEHRSTlMA1ucVCPG/hSF2j1I3qmmdtjvhQgAAAKtJREFUKM91ktsWxRAMRIW6R+X/v/ag6nKk+6VWxzJjRCgfgneCxVBB81quGuHFaZfNiSiKL4jAHvQQkjjkzHNgmhZY7W5aZLXHz3ES9KBcmLiW88fbBhMmvZe/T7dRPxJZtyFGwSWo/2wUCPzG8qKeL+x5KQMgdacs5WaBWHY0hEK1GZYbmv4HpYZ1gLB65LZUug7QMiNx+rutsZpFz3bTOKKjQhrzZJNt3x/S/BL1m+jD9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/suspension/shopping.png
// module id = EoQp
// module chunks = 6